import Button from '@components/Button';
import styles from './NumberPagination.module.scss';
import { useEffect } from 'react';

interface Props {
  value: number;
  setValue: (val: number) => void;
  total: number;
  labels: string[];
  disabledIndexes: number[];
  onIndexChange?: (index: number, init?: boolean) => void;
}

function NumberPagination({
  value,
  setValue,
  total,
  labels,
  disabledIndexes,
  onIndexChange,
}: Props) {
  const maxVisible = 100;
  let start = Math.floor((value - 1) / maxVisible) * maxVisible;
  let end = Math.min(start + maxVisible, total);

  if (end - start < maxVisible && end === total) {
    start = Math.max(0, end - maxVisible);
  }

  const handlePrev = () => {
    const newValue = Math.max(value - maxVisible, 1);
    setValue(newValue);
  };

  const handleNext = () => {
    const newValue = Math.min(value + maxVisible, total);
    setValue(newValue);
  };

  return (
    <>
      <div className={styles['Pagination-Box']}>
        {/* <Button
          disabled={start === 0}
          onClick={handlePrev}
        >
          &lt;-
        </Button> */}
        {Array.from({ length: end - start }, (_, i) => start + i + 1).map(
          (num) => {
            const index = num - 1;
            const label = labels?.[index] ?? num;
            const isDisabled = disabledIndexes.includes(index);

            if (isDisabled) return null;

            return (
              <Button
                key={num}
                onClick={() => {
                  if (!isDisabled) {
                    onIndexChange?.(index);
                    setValue(num);
                  }
                }}
                color={num === value ? 'primary' : ''}
                disabled={isDisabled}
              >
                {label}
              </Button>
            );
          },
        )}
        {/* <Button
          disabled={end >= total}
          onClick={handleNext}
        >
          -&gt;
        </Button> */}
      </div>
    </>
  );
}

export default NumberPagination;
